export default __webpack_public_path__ + "static/media/job-location-icon.1ffa30ff.svg";